import { render, staticRenderFns } from "./PlaceFilter.vue?vue&type=template&id=5fdea0cb"
import script from "./PlaceFilter.vue?vue&type=script&lang=js"
export * from "./PlaceFilter.vue?vue&type=script&lang=js"
import style0 from "./PlaceFilter.vue?vue&type=style&index=0&id=5fdea0cb&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fdea0cb')) {
      api.createRecord('5fdea0cb', component.options)
    } else {
      api.reload('5fdea0cb', component.options)
    }
    module.hot.accept("./PlaceFilter.vue?vue&type=template&id=5fdea0cb", function () {
      api.rerender('5fdea0cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Calendar/PlaceFilter.vue"
export default component.exports